import { Log, User, UserManager } from 'oidc-client';
import { constantsOauth } from '../config';

// Read by public/signin-callback.html, which builds its own UserManager.
export const CALLBACK_SETTINGS_KEY = 'oidc.callbackSettings';

export class AuthService {
  public userManager: UserManager;

  constructor() {
    const settings = {
      authority: constantsOauth.stsAuthority,
      client_id: constantsOauth.clientId,
      //client_secret: "bar",
      redirect_uri: `${constantsOauth.clientRoot}signin-callback.html`,
      silent_redirect_uri: `${constantsOauth.clientRoot}silent-renew.html`,
      // tslint:disable-next-line:object-literal-sort-keys
      post_logout_redirect_uri: `${constantsOauth.clientRoot}`,
      response_type: 'code',
      scope: constantsOauth.clientScope,
      metadata: constantsOauth.metadata
    };
    this.userManager = new UserManager(settings);

    if (constantsOauth.metadata)
      localStorage.setItem(CALLBACK_SETTINGS_KEY, JSON.stringify({ metadata: constantsOauth.metadata }));
    else localStorage.removeItem(CALLBACK_SETTINGS_KEY);

    Log.logger = console;
    Log.level = Log.INFO;
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
}
